// Phase 2.3 Lite — Template-side link panel.
// Groups Internal preview + Public demo for one template into a single
// consistent surface. Mounted at the bottom of each Template Library card.

import React from 'react';
import LinkActionRow from '../links/LinkActionRow';
import { LINK_TYPES } from '../../lib/utils/linkUtils';

export default function TemplateLinksPanel({
  template,
  onGenerateDemo,
  onDisableDemo,
  busy = false,
}) {
  if (!template) return null;
  const status = template.status || 'draft';
  const isApproved = status === 'approved';
  const isArchived = status === 'archived';

  const internalPreviewUrl = `/studio/templates/${template.id}/preview`;
  const demoUrl = template.demo_url_enabled && template.demo_slug
    ? `/demo/${template.demo_slug}`
    : null;

  // Demo generation rules (mirrors backend Phase 2.1 Lite):
  //   - approved template, demo off → Generate enabled
  //   - approved template, demo on  → show Live + Disable + Copy/Open
  //   - draft / internal_review     → Generate locked with tooltip
  //   - archived                    → Generate locked, "Archived" tooltip
  let demoDisabled = false;
  let demoDisabledReason = '';
  if (isArchived) {
    demoDisabled = true;
    demoDisabledReason = 'Archived templates cannot host a demo link.';
  } else if (!isApproved && !demoUrl) {
    demoDisabled = true;
    demoDisabledReason = 'Approve this template before generating a public demo link.';
  }

  const demoStatus = demoUrl ? 'live' : 'disabled';

  return (
    <div
      className="space-y-2"
      data-testid={`template-links-panel-${template.id}`}
    >
      <LinkActionRow
        type={LINK_TYPES.INTERNAL_TEMPLATE_PREVIEW}
        url={internalPreviewUrl}
        status="internal"
        testidPrefix={`tpl-${template.id}-internal`}
      />
      <LinkActionRow
        type={LINK_TYPES.PUBLIC_DEMO}
        url={demoUrl}
        status={demoStatus}
        disabled={demoDisabled}
        disabledReason={demoDisabledReason}
        helperText={demoDisabled ? demoDisabledReason : undefined}
        busy={busy}
        onGenerate={!demoDisabled && !demoUrl ? () => onGenerateDemo(template) : undefined}
        onDisable={demoUrl ? () => onDisableDemo(template) : undefined}
        testidPrefix={`tpl-${template.id}-demo`}
      />
    </div>
  );
}
